import { Component, OnInit, Inject, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-message-layout',
    templateUrl: './message-layout.component.html',
    standalone: false
})
export class MessageLayoutComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.document.body.classList.remove('background-image');
    this.document.body.classList.add('body-content');
  }

}
